import { DebugSection } from 'components/minute/sidebar/MapSidebar/DebugSection';
import { ExperimentalSection } from 'components/minute/sidebar/MapSidebar/ExperimentalSection';
import { FloorsSettingSection } from 'components/minute/sidebar/MapSidebar/FloorsSettingSection';
import { GlobalMarkersSettingsSection } from 'components/minute/sidebar/MapSidebar/GlobalMarkersSettingsSection';
import { MapSettingsSection } from 'components/minute/sidebar/MapSidebar/MapSettingsSection';
import { useContext } from 'react';
import { GlobalContext } from 'session/state/context';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MapSidebar = (props: Props): JSX.Element => {
    const {
        state: { loggedUser }
    } = useContext(GlobalContext);

    return (
        <S_MapSidebar className={props.className}>
            <MapSettingsSection />
            <FloorsSettingSection />
            {/* {access.isExperimental && <CategoriesSettingSection />} */}
            {/* {SUBSCRIPTION_CONFIG[loggedUser?.subscriptionTier]?.name !== 'Full' && (
                <UpgradeSection />
            )} */}
            <GlobalMarkersSettingsSection />
            {loggedUser && <ExperimentalSection />}
            <DebugSection />
        </S_MapSidebar>
    );
};

const S_MapSidebar = styled.div`
    width: 100%;
    padding: 0 0 200px 0;
`;
